export const category_th = [
  {
    title: 'Désignation',
    key: 'designation',
  },
  {
    title: 'Description',
    key: 'description',
  },

  {
    title: 'Nom du restaurant',
    key: 'designation',
  },
  {
    title: 'Date de création',
    key: 'createdAt',
  },
  {
    title: 'Date de mis à jour',
    key: 'updatedAt',
  },
  {
    title: 'Actions',
    key: 'action',
  },
];
